import { AbstractControl, ValidationErrors } from '@angular/forms';

export function cpfValido(control: AbstractControl): ValidationErrors | null {
  const value = control.value;

  if (!value) {
    return null;
  }

  const digits = String(value).replace(/\D/g, '');

  if (digits.length !== 11) {
    return { cpfInvalido: true };
  }

  // Rejeita CPF com todos os dígitos iguais
  if (/^(\d)\1{10}$/.test(digits)) {
    return { cpfInvalido: true };
  }

  return null;
}
